





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';

@Component
export default class PrescriptionFormObservation extends BaseComponent {
  @Prop()
  public item;
  @Prop()
  public disabled?: boolean;    
}
